
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 545 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M-6.7 87.2c0-9.6 7.8-17.4 17.5-17.4h69.8c9.6 0 17.5 7.8 17.5 17.4s-7.8 17.4-17.5 17.4H10.7c-9.6.1-17.4-7.8-17.4-17.4zm209.4 0c0-9.6 7.8-17.4 17.5-17.4h314.1c9.6 0 17.5 7.8 17.5 17.4s-7.8 17.4-17.5 17.4H220.1c-9.6.1-17.4-7.8-17.4-17.4zM-6.7 412.8c0-9.6 7.8-17.4 17.5-17.4h69.8c9.6 0 17.5 7.8 17.5 17.4 0 9.6-7.8 17.4-17.5 17.4H10.7c-9.6 0-17.4-7.8-17.4-17.4zm209.4 0c0-9.6 7.8-17.4 17.5-17.4h314.1c9.6 0 17.5 7.8 17.5 17.4 0 9.6-7.8 17.4-17.5 17.4H220.1c-9.6 0-17.4-7.8-17.4-17.4zM-6.7 250c0-9.6 7.8-17.4 17.5-17.4h314.1c9.6 0 17.5 7.8 17.5 17.4 0 9.6-7.8 17.4-17.5 17.4H10.7c-9.6 0-17.4-7.8-17.4-17.4zm453.7 0c0-9.6 7.8-17.4 17.5-17.4h69.8c9.6 0 17.5 7.8 17.5 17.4 0 9.6-7.8 17.4-17.5 17.4h-69.8c-9.7 0-17.5-7.8-17.5-17.4z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M150.3 34.9C121.4 34.9 98 58.3 98 87.2s23.4 52.3 52.4 52.3 52.4-23.4 52.4-52.3-23.5-52.3-52.5-52.3zM63.1 87.2C63.1 39 102.2 0 150.3 0s87.3 39 87.3 87.2-39.1 87.2-87.3 87.2-87.2-39-87.2-87.2zM150.3 360.5c-28.9 0-52.4 23.4-52.4 52.3s23.4 52.3 52.4 52.3 52.4-23.4 52.4-52.3-23.4-52.3-52.4-52.3zm-87.2 52.3c0-48.2 39.1-87.2 87.3-87.2s87.3 39 87.3 87.2-39.2 87.2-87.4 87.2-87.2-39-87.2-87.2zM394.7 197.7c-28.9 0-52.4 23.4-52.4 52.3s23.4 52.3 52.4 52.3S447 278.9 447 250s-23.4-52.3-52.3-52.3zM307.4 250c0-48.2 39.1-87.2 87.3-87.2s87.3 39 87.3 87.2-39.1 87.2-87.3 87.2-87.3-39-87.3-87.2z"}})])
          )
        }
      }
    